import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

var AppDatePicker = /*#__PURE__*/function (_Vue) {
  _inherits(AppDatePicker, _Vue);

  var _super = _createSuper(AppDatePicker);

  function AppDatePicker() {
    var _this;

    _classCallCheck(this, AppDatePicker);

    _this = _super.apply(this, arguments);
    _this.model = '';
    _this.show = false;
    _this.rules = {
      required: function required(value) {
        return !!value || 'Required.';
      }
    };
    return _this;
  }

  _createClass(AppDatePicker, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value;
    }
  }, {
    key: "clearModel",
    value: function clearModel() {
      this.valueChangedHandler('');
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged(val) {
      this.model = val;
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler(val) {
      this.model = val;
      this.show = false;
      return val;
    }
  }, {
    key: "submit",
    value: function submit() {}
  }, {
    key: "allowedDates",
    value: function allowedDates(val) {
      return this.$moment().diff(val, 'days') > 0;
    }
  }]);

  return AppDatePicker;
}(Vue);

__decorate([Prop(String)], AppDatePicker.prototype, "value", void 0);

__decorate([Prop(String)], AppDatePicker.prototype, "label", void 0);

__decorate([Prop({
  type: String
})], AppDatePicker.prototype, "placeholder", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppDatePicker.prototype, "required", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 289
})], AppDatePicker.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 36
})], AppDatePicker.prototype, "height", void 0);

__decorate([Prop({
  type: String,
  default: 'date'
})], AppDatePicker.prototype, "type", void 0);

__decorate([Prop({
  type: String,
  default: '2099-12-31'
})], AppDatePicker.prototype, "max", void 0);

__decorate([Prop({
  type: String,
  default: '1900-12-31'
})], AppDatePicker.prototype, "min", void 0);

__decorate([Prop({
  type: Boolean
})], AppDatePicker.prototype, "disabled", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], AppDatePicker.prototype, "showClear", void 0);

__decorate([Watch('value')], AppDatePicker.prototype, "onValueChanged", null);

__decorate([Emit('input')], AppDatePicker.prototype, "valueChangedHandler", null);

__decorate([Emit()], AppDatePicker.prototype, "submit", null);

AppDatePicker = __decorate([Component], AppDatePicker);
export default AppDatePicker;